import {  Box, Container, Stack, Tooltip, Typography,
    Link, Button, } from '@mui/material'
import React, { useState } from 'react'
import ShopModal from './ShopModal'
import MusicModal from './MusicModal'
import TipModal from './TipModal'

const ShowLander = () => {
    const [ showTip, setShowTip ] = useState(false)
    const [ showMusic, setShowMusic ] = useState(false)
    const [ showMerch, setShowMerch ] = useState(false)
  
    const sharePic = `https://res.cloudinary.com/dzxzdsnha/image/upload/v1744816887/RE%20Branding/RE_Music_GreetingCard_cmxpc7.jpg`  
    return (
<Box 
className='center'
sx={{
    flex:1,
    display:'flex',
    flexDirection:'column',
    height:'95vh',
    maxWidth:'600px',
    width:'100vw', maxHeight:'100vh',  
    // borderRadius:'5px',
    backgroundColor: 'rgba( 0, 0, 0, 0.6)',
    backgroundImage: 'url("/assets/BodyBG2.png")',
    // backgroundImage:'url("/assets/Gradient_01_Frame2.png")',
    backgroundAttachment: 'cover',
    backgroundRepeat: 'no-repeat',
    // justifyContent: 'center',
    margin:'auto',
    boxShadow:'0px 0px 10px 3px rgba(0, 0, 0, 0.6),inset 0px 0px 10px 5px rgba(0, 0, 0 ,0.7)',}}>
    
    <Stack className='center green-border-pulse '
          sx={{position:'relative',
              // position:'absolute',
              // top:'2.5rem',
              // left:'0.75rem',
              width:'80%', height:'fit-content', 
              // backgroundColor:'rgba(0,0,0,0.6)', 
              backdropFilter:'blur(5px)',
              padding:'2rem 0.5rem',justifyContent:'center',
              borderRadius:'5px',  
              gap:'0.75rem', alignItems:'center',
            
              alignContent:'center', 
              border:'2px ridge #00FF00',
              boxShadow:'0px 0px 10px 3px rgba(0, 0, 0, 0.6),inset 0px 0px 10px 5px rgba(0, 255, 0 ,0.7)',
          }}>
            
<Typography variant='bold' sx={{ color:'#00FF00', fontSize:'2rem',fontaFamily:'Gilroy,sans-serif'}}>Welcome!</Typography>
    <Box component='img'
    src={sharePic}
    sx={{borderRadius:'5px', width:'80%',
        border:'1px solid rgba(0, 0, 0,1)',
        boxShadow:'0px 0px 10px 3px rgba(0, 0, 0, 0.6),inset 0px 0px 5px 3px rgba(0, 255, 0 ,0.7)',
    }}
    />

    <Box sx={{
              position:'relative',
              // top:'2.5rem',
              // left:'0.75rem',
              width:'70%', height:'fit-content', 
              backgroundColor:'rgba(0,0,0,0.6)', 
              backdropFilter:'blur(10px)',
              justifyContent:'center',
              borderRadius:'5px',  
              
              border:'1px solid #00FF00',
              boxShadow:'0px 0px 10px 3px rgba(0, 0, 0, 0.6),inset 0px 0px 10px 5px rgba(0, 0, 0 ,0.7)',
        
          }}>
              <Box sx={{ position: 'sticky', top: 0, left: 0, width: '100%', height: '1rem', 
                        background: '#F6F6F6',justifyContent:'center', textAlign:'center' }}>
                        <Typography sx={{ color: '#858585', fontSize: '0.75rem' }}>
                            ✊🔥🙏🙌THANK❤️YOU🙌🙏🔥✊
                             {/* Thank You! */}
                             </Typography>
                    </Box>

        <Stack sx={{gap:'0.5rem', alignItems:'center',
              
              alignContent:'center',padding:'1.5rem' }} >
            
                            <Button variant='outlined' 
                              className='blink'
                            sx={{
                            width:'200px',
                            backgroundColor:'rgba(0,214,78)',color:'#fff'}}
                            onClick={()=>{
                                setShowTip(true)
                            }}
                            >
                            <b>Tip</b>  
                        </Button>  
                        
                        <Button variant='outlined'
                          className='blink-2'
                           sx={{
                            width:'200px',
                            backgroundColor:'rgba(0,140,255)',color:'#fff'}} 
                            onClick={()=>{
                                setShowMerch(true)
                            }}
                            >
                    
                            <b>Merch</b> 
                        </Button>  
                    
                        {/* <Link to='musiclander/' target='_blank'> */}
                            <Button variant='outlined' 
                            className='blink'
                            sx={{
                            width:'200px',
                            backgroundColor:'rgba(84,51,255,1)',color:'#fff'}}
                            onClick={()=>{
                                // setShowMusic(true)
                        window.open('/musiclander','_blank')
                            }}
                            >
                    
                            <b>Music</b> 
                        </Button>  
        {/* </Link> */}
        </Stack>
    </Box>

                {/* <Avatar //sx={{}} 
                    {...stringAvatar(listener?.preferredName?listener?.preferredName:listener?.email)}
                    // src={`https://res.cloudinary.com/dzxzdsnha/image/upload/v1686761978/Rex_Entropy_Icon_Glow3_mxyw45.png`}
                    />
                    <Favorite sx={{color:'red', position:'absolute', 
                    left:'2.25rem', bottom:'-1.25rem', fontSize:'0.85rem'}}/> */}
                </Stack>
                <ShopModal shopModalOpen={showMerch} setShopModalOpen={setShowMerch} />
                {/* <MusicModal sx={{zIndex:99999999}} musicModalOpen={showMusic} setMusicModalOpen={setShowMusic} /> */}
                <TipModal tipModalOpen={showTip} setTipModalOpen={setShowTip} view='show'/>
    </Box>
  )
}

export default ShowLander